"use client";

import { useState } from "react";
import Container from "@/components/elements/Container";
import rte from '@/utils/rte';
import Block from "@/components/elements/Block";

const ChevronIcon = ({ className }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    className={className}
    fill="currentColor"
    viewBox="0 0 48 48"
    style={{ minWidth: "2rem" }}
  >
    <path d="m14.8 16.4 9.2 9.2 9.2-9.2 2.8 2.9-12 12-12-12Z" />
  </svg>
);

const FeaturesAccordion = ({ block = {}, position }) => {
  const {
    features = [],
    first_feature_content_open = false,
    settings = {},
  } = block;

  const textColor = settings?.text_color?.color_selector || "text-white";
  const dividerColor =
    settings?.divider_color?.color_selector || "border-white";

  const sectionId = `accordion-${
    position !== undefined ? position : "default"
  }`;

  const [openIndex, setOpenIndex] = useState(
    () => (first_feature_content_open ? 0 : null)
  );

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };

  return (
    <Block settings={settings} name="features_accordion"
      id={sectionId}
    >
      <Container className="lg:max-w-4xl px-4 mx-auto">
        {features.map((item, i) => (
          <div key={item._metadata?.uid ?? item.heading ?? i} className={`border-b-2 ${dividerColor} pb-4 mb-4`}>
              <button
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
                aria-controls={`accordion-panel-${sectionId}-${i}`}
                className="w-full flex items-center justify-between text-left cursor-pointer"
              >
                {/* BL-472: h2, not h3. This block renders no heading of its
                    own, so on the instructions pages the items sat directly
                    under the page h1 and skipped a level. */}
                <h2
                  id={`accordion-heading-${sectionId}-${i}`}
                  className={`font-worksans text-sm md:text-base ${textColor}`}
                >
                  {item.heading}
                </h2>

                <ChevronIcon
                  className={`h-6 transition-transform ${textColor} ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                />
              </button>

              {item.content && (
                <div
                  id={`accordion-panel-${sectionId}-${i}`}
                  role="region"
                  aria-labelledby={`accordion-heading-${sectionId}-${i}`}
                  className={`pt-4 font-worksans text-base ${textColor} ${openIndex !== i ? 'hidden' : ''}`}
                  dangerouslySetInnerHTML={{ __html: rte(item.content) }}
                />
              )}
          </div>
        ))}
      </Container>
    </Block>
  );
};

export default FeaturesAccordion;
